import React, { useEffect, useState, useRef } from 'react';
import { useParams }       from 'react-router-dom';
import AxiosClient         from '../../assets/AxiosClient';
import { useReactToPrint } from 'react-to-print';
import { useStateContext } from '../../Contexts/ContextProvider';

const PublicProfile = () => {
  const { code } = useParams();
  const { API }  = useStateContext();

  const [user,    setUser]    = useState(null);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(null);

  // 1) Single ref for your printable content
  const printRef = useRef(null);

  // 2) Top‑level hook using contentRef (v3.x API)
  const handlePrint = useReactToPrint({
    contentRef: printRef,
    documentTitle: user?.name
      ? `${user.name}_attendant_profile`
      : 'Profile',
    removeAfterPrint: true,
  });

  // Fetch data
  useEffect(() => {
    AxiosClient.get(`public/verification/${code}`)
      .then(res => {
        setUser(res.data.user);
        setLoading(false);
      })
      .catch(() => {
        setError('User not found');
        setLoading(false);
      });
  }, [code]);

  if (loading) return <h1 className="text-center mt-5">Loading…</h1>;
  if (error)   return <h2 className="text-danger text-center">{error}</h2>;

  return (
    <div className="container my-4">
      {/* 3) Button just calls the print handler */}
      <button onClick={handlePrint} className="btn btn-danger mb-4">
        Print PDF
      </button>

      {/* 4) Wrap _all_ printable markup in this ref */}
      <div ref={printRef}>
        <div className="d-flex justify-content-between align-items-center m-4">
          <img  src="https://anbar-bcs.org/logo.png"     alt="Logo" width={100} />
          <img src="https://anbar-bcs.org/icid-logo.png" alt="Logo" width={100} />
        </div>

        <h2 className="text-center font-weight-bold mb-4">
         1st ANBAR
BREAST CANCER SUMMIT
        </h2>

        <div className="card">
          <div className="card-body text-center">
            <img
              src={`${API}${user.image}`}
              alt="Profile"
              crossOrigin="anonymous"

              className="rounded-circle mb-3"
              style={{ width: 120, height: 120, objectFit: 'cover' }}
            />
            <h4 className="card-title font-weight-bold">{user.name}</h4>
            <p><strong>Position:</strong>      {user.position}</p>
            <p><strong>Organization:</strong> {user.organization}</p>

            <div className="mt-3">
              <p className="text-success font-weight-bold">Registered</p>
            </div>

            <div className="mt-4">
              <h5 className="font-weight-bold">Attend Dates</h5>
              {user.dates.map(d => (
                <p key={d.id} className="font-weight-bold text-dark">
                  {d.date}
                </p>
              ))}
            </div>

            <div className="mt-3">
              <h5>
                <span className="text-danger">Conference: </span>
                {user.conference.en_title}
              </h5>
              <h5>
                <span className="text-danger">Note: </span>
                {user.attendance.report ? user.attendance.report  : " no limit specifications" }
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PublicProfile;
